import { AVATARS, type AvatarId } from "@bing/shared";
import type { ReactNode } from "react";
import { Avatar } from "./Avatar";

export function AvatarPicker({
  value,
  onChange,
}: {
  value: AvatarId;
  onChange: (avatarId: AvatarId) => void;
}): ReactNode {
  return (
    <div className="avatar-picker" role="radiogroup" aria-label="آواتار">
      {AVATARS.map((avatarId) => (
        <button
          key={avatarId}
          type="button"
          role="radio"
          aria-checked={avatarId === value}
          className={`avatar-option${avatarId === value ? " is-selected" : ""}`}
          onClick={() => onChange(avatarId)}
        >
          <Avatar avatarId={avatarId} size={48} />
        </button>
      ))}
    </div>
  );
}
